import { PLACEHOLDER_SRC } from '../lib/photoFiles';
import { usePhotoSrc } from '../hooks/usePhotoSrc';
import type { Photo } from '../types';

type Props = {
  photo: Photo;
  onOpen: (id: string) => void;
};

export function OrnateFrame({ photo, onOpen }: Props) {
  const stored = photo.thumbUrl ?? photo.displayUrl;
  const fetched = usePhotoSrc(stored ? '' : photo.id);
  const src = stored ?? fetched.src ?? PLACEHOLDER_SRC;

  return (
    <button
      type="button"
      className="frame"
      onClick={() => onOpen(photo.id)}
      aria-label={`Open ${photo.filename}`}
    >
      <div className="frame-inner">
        <img
          src={src}
          alt=""
          width={photo.width}
          height={photo.height}
          loading="lazy"
          decoding="async"
          className={src === PLACEHOLDER_SRC ? 'is-placeholder' : undefined}
          style={{ aspectRatio: `${photo.width} / ${photo.height}` }}
        />
      </div>
      <div className="cap">{photo.caption || photo.filename}</div>
    </button>
  );
}
